<template>
  <nav-menu
    name="Group gift cards"
    title="Add gift cards"
    subtitle="Your whole group can add to one gift card"
    action="View all gift cards"
    :icon="mdiWalletGiftcard"
    :to="{ name: 'catalog-gift-cards' }"
    v-bind="$attrs" v-on="$listeners"
  >

    <v-list class="transparent" dense>
      <v-list-item
        class="li-pop font-weight-bold ec-dark-blue--text"
        :to="{ name: 'catalog-gift-cards' }"
      >
        <v-icon small v-html="mdiWalletGiftcard" />
        <div>All gift cards</div>
        <v-icon small v-html="mdiChevronRight" />
      </v-list-item>
    </v-list>

    <v-divider />

    <div class="root-grid">

      <div>
        <div class="caption pt-3 px-3">Popular gift cards</div>
        <v-list class="transparent" dense>
          <v-list-item
            v-for="[ country, name, alias, img ] in MERCHANTS" :key="name"
            class="li-pop ec-dark-blue--text"
            :to="{ name: 'catalog-gift-cards', params: { country, alias } }"
          >
            <!-- <v-icon v-bind:style="{ color: c.icon_color }" small v-html="c.icon" /> -->
            <v-img class="v-card v-sheet ml-n2" width="48" max-width="48" :aspect-ratio="300 / 190" :src="img" />
            <div v-text="name" />
            <v-icon small v-html="mdiChevronRight" />
          </v-list-item>
        </v-list>
      </div>

      <div>
        <v-list class="transparent" dense>
          <v-list-item
            v-for="[ name, icon, route ] in FEATURES" :key="name"
            class="li-pop font-weight-bold ec-dark-blue--text"
            :to="route"
          >
            <v-icon small v-html="icon" />
            <div v-text="name" />
            <v-icon small v-html="mdiChevronRight" />
          </v-list-item>
        </v-list>

        <div v-if="false" class="pa-3">
          <div class="caption">Search all gift cards</div>
          <v-text-field
            class="mt-2 white"
            label="Search" outlined dense rounded hide-details multiple single-line clearable readonly
            :append-icon="mdiMagnify"
            @click="$router.push({ name: 'catalog-gift-cards' })"
          />
        </div>
      </div>

    </div>

  </nav-menu>
</template>


<style scoped>
.root-grid {
  display: grid;
  grid-template-columns: 1fr;
}

.root-grid > *:first-child {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

@media (min-width: 600px) {
  .header .root-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .header .root-grid > *:first-child {
    border-bottom: none;
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }
}

@media (min-width: 960px) {
  .root-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .root-grid > *:first-child {
    border-bottom: none;
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }
}

.li-pop:hover > .v-image:nth-child(1) {
  transform: scale(1.2);
}
</style>


<script>
import NavMenu from '@/components/NavMenu.vue';
import iconPathCalendarRecurring from 'raw-loader!@/assets/icon-path-calendar-recurring.txt';
import { mdiCheckboxMultipleBlank, mdiEmailMultiple, mdiCalendarStart, mdiEarth, mdiWalletGiftcard, mdiMagnify, mdiChevronRight, mdiInformation } from '@mdi/js';

const MERCHANTS = [
  [ 'us', 'Amazon', 'AMZ-US', 'https://gift.runa.io/static/product_assets/AMZ/AMZ-card.png' ],
  [ 'us', 'Doordash', 'DDASH-US', 'https://gift.runa.io/static/product_assets/DDASH-US/DDASH-US-card.png' ],
  // [ 'us', 'Apple', 'DC82VBYLI4CC', 'https://giftrocket-s3.imgix.net/Brands/US/iTunes/Digital/B2B/iTunes_B2B.png' ],
  // [ 'us', 'Google', 'PLAY-US', 'https://gift.runa.io/static/product_assets/PLAY-US/PLAY-US-card.png' ],
  [ 'us', 'Home Depot', 'DEPOT-US', 'https://giftrocket-s3.imgix.net/Brands/US/The+Home+Depot/Digital/The+Home+Depot.png' ],
  // [ 'us', `Lowe's`, 'LOWES-US', 'https://gift.runa.io/static/product_assets/LOWES-US/LOWES-US-card.png' ],
  [ 'us', 'REI', 'REI-US', 'https://gift.runa.io/static/product_assets/REI-US/REI-US-card.png' ],
  [ 'us', 'Sephora', 'SEPHRA-US', 'https://gift.runa.io/static/product_assets/SEPHRA-US/SEPHRA-US-card.png' ],
  [ 'us', 'Starbucks', 'SBUX-US', 'https://giftrocket-s3.imgix.net/Brands/US/Starbucks/Digital/starbucks_image_for_certificate.png' ],
  [ 'us', 'Target', 'TARGT-US', 'https://giftrocket-s3.imgix.net/Brands/US/Target/Digital/Target.png' ],
  [ 'us', 'Uber / Uber Eats', 'UBER-US', 'https://gift.runa.io/static/product_assets/UEATS-US/UEATS-US-card.png' ],
  [ 'us', 'Ulta Beauty', 'ULTAB-US', 'https://gift.runa.io/static/product_assets/ULTAB-US/ULTAB-US-card.png' ],
  [ 'us', 'Visa', 'VISA-US', 'https://cdn.ellacard.com/giftcard_tr_visa.png' ],
  [ 'us', 'Walmart', 'WMART-US', 'https://gift.runa.io/static/product_assets/WMART-US/WMART-US-card.png' ]
];

const FEATURES = [
  [ 'Learn more about gift cards', mdiInformation, { name: 'start-gift-cards' } ],
  [ 'Schedule automated cards', iconPathCalendarRecurring, { name: 'automation' } ],
  [ 'Place a bulk order', mdiCalendarStart, { name: 'batch-order' } ],
  [ 'Send internationally', mdiEarth, { name: 'international-gift-cards' } ]
];

export default {
  name: 'nav-menu-group-gift-cards',

  components: {
    NavMenu
  },

  created() {
    Object.assign(this, { FEATURES, MERCHANTS, mdiCheckboxMultipleBlank, mdiEarth, mdiWalletGiftcard, mdiMagnify, mdiChevronRight });
  }
}
</script>
